export const LAST_USED_PROVIDER_KEY = 'last_used_provider';

export const LOCALE_SELECTION = 'user_locale';

export const REMEMBER_LOGIN_KEY = 'remember_login';

export const STATE_STORAGE_KEY_PREFIX = 'app_client_state_';

export const LAST_APN_PROVIDER = 'last_apn_provider';
